import { Typography, Button, Input, Select, message, Checkbox } from "antd";
import { useEffect, useState } from "react";
import "./redflag.scss";
import { useUserFilesTabs } from "./UserFilesTabsContext";
import { patchPostFetcher } from "../../../utils/fetcher";
import { useLocation } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import { AppModal, AppUpload } from "../../../components/common";

const { Text } = Typography;

type RedFlagPayload = {
  redFlagStatus: boolean;
  emailContent: {
    to: any;
    body: string;
    subject: string;
    bcc: string[];
    attachments: [];
 
  };
};

export default function RedflagModal() {
  const {
    redflagModal,
    setRedflagModal,
    selectedModalObjCounselor,
    userDetails,
    redFlagChecked,
    setRedFlagChecked,
  } = useUserFilesTabs();

  const [subject, setSubject] = useState("");
  const [body, setBody] = useState(``);

  const [attachments, setAttachments] = useState<File[]>([]);
  const [isConfirm, setIsConfirm] = useState(false);
  const [confirmcheck,setConfirmcheck] = useState(false);

  const handleAttach = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const file = e.target.files[0];

    const MAX_FILE_SIZE = 10 * 1024 * 1024;
    if (file.size > MAX_FILE_SIZE) {
      message.error("File size should not exceed 10MB");
      e.target.value = "";
      return;
    }

    setAttachments([...attachments, file]);
  };

  const removeAttachment = (index: number) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDraft = () => {
    setRedFlagChecked(false);
    console.log("Draft saved");
    setRedflagModal(false);
    setIsConfirm(false);
  };
  const [toList, setToList] = useState<any[]>([
    // userDetails?.data?.personalSafety?.emergencyContact?.email
  ]);

  const isProd = process.env.NODE_ENV === "production";

  const [bccList, setBccList] = useState<string[]>([
    isProd ? "deeksha@soulstudio.world" : "udhaya@soulstudio.world",
  ]);

  const API_URL = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const clientId = location.pathname.split("/")[3];

 useEffect(() => {
  const email = userDetails?.data?.personalSafety?.emergencyContact?.email;
  const valueget: string[] = JSON.parse(localStorage.getItem("Hremail") || "[]");

  setToList(
    [email, ...valueget]
      .filter(Boolean)
      .filter((item, index, arr) => arr.indexOf(item) === index)
  );
}, []);

  


  

  const { trigger: sessionReportTrigger, isMutating } = useSWRMutation<
    any,
    any,
    string | null,
    RedFlagPayload
  >(
    clientId ? `${API_URL}/session/user/${clientId}/red-flag` : null,
    (url, { arg }) =>
      patchPostFetcher({
        url,
        data: arg,
        method: "POST",
      }),
  );

  console.log(toList, "userdetailsuserdetails");

  const handleSend = async () => {
    const bodyHtml = `<div style="font-family:Arial;line-height:1.6">
  ${body.replace(/\n/g, "<br/>")}
</div>`;

    const payload: RedFlagPayload = {
      redFlagStatus: redFlagChecked,
      // reasons: ["sensitive_disclosure_end_session"],
       emailContent: {
        to: toList,
        body: bodyHtml,
        subject,
        bcc: bccList.length ? bccList : [],
        attachments: []
      },
     
    };

    try {
      await sessionReportTrigger(payload);
      message.success("Email sent Successfully");
      setRedflagModal(false);
      setIsConfirm(false);
      setRedFlagChecked(false);
      setBccList([]);
    } catch (err) {
      setRedflagModal(false);
      setIsConfirm(false);
      setRedFlagChecked(false);
    }
  };

  const handleActive = () => {
    if (!toList.length) {
      message.error("Recipient email is required");
    } else if (!subject.trim()) {
      message.error("Subject is required");
    } else if (!body.trim()) {
      message.error("Email body is required");
    } else {
      setIsConfirm(true);
    }
  };

  return (
    <AppModal
      open={redflagModal}
      title={isConfirm ? "Confirm Redflag Notification" : "Redflag Support Email"}
      footer={
        isConfirm ? null : (
          <>
            <Button onClick={handleDraft}>Save as Draft</Button>
            <Button type="primary" onClick={handleActive}>
              Send Email
            </Button>
          </>
        )
      }
      className="redflagModalalt"
      onCancel={() => {
        setRedflagModal(false);
        setRedFlagChecked(false);
        setBody("");
        setBccList([]);
        setAttachments([]);
        setIsConfirm(false);
      }}
    >
      {isConfirm === false ? (
        <>
          {/* Header */}
          <div className="modalHeader">
            <div>
              <Text className="subtitle">
                Complete and send this email to initiate Redflag support and
                notify the designated Company and Emergency Contact.
              </Text>
            </div>
          </div>

          {/* Body */}
          <div className="modalBody">
            <div className="recipientRow">
              <Text className="label">To</Text>

              <Select
                mode="tags"
                open={false}
                showArrow={false}
                bordered={false}
                value={toList}
                onChange={setToList}
                tokenSeparators={[",", " "]}
                className="recipientInput danger"
                placeholder="Recipients"
              />
            </div>

            <div className="recipientRow">
              <Text className="label">Bcc</Text>

              <Select
                mode="tags"
                open={false}
                showArrow={false}
                bordered={false}
                value={bccList}
                onChange={setBccList}
                tokenSeparators={[",", " "]}
                className="recipientInput primary"
              />
            </div>

            <div className="divider" />

            <Input
              className="subjectInput"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Add a subject"
            />

            <Input.TextArea
              className="emailBody"
              value={body}
              onChange={(e) => setBody(e.target.value)}
              autoSize={{ minRows: 10 }}
            />

            {/* ATTACHMENTS */}
            <div className="attachmentRow">
              <AppUpload kind="file" compact multiple handleFileUpload={handleAttach} />

              {attachments.map((file, i) => (
                <div className="fileChip" key={i}>
                  {file.name}
                  <span onClick={() => removeAttachment(i)}>✕</span>
                </div>
              ))}
            </div>
          </div>

        </>
      ) : (
        <div className="confirmWrapper">
          <div className="confirmCard">
            <div className="confirmContent">

             

              <Text className="sectionTitle">You are about to send an official Redflag support email to the designated contacts. This action cannot be undone. Please review all details carefully before sending.</Text><br/>
             
            </div>
          </div>

          <div className="confirmCheckboxRow">
            <Checkbox onChange={(e)=>setConfirmcheck(e.target.checked)} />
            <Text>
              I confirm that this escalation is necessary and appropriate and
              that I have reviewed the email content carefully.
            </Text>
          </div>

          <div className="confirmActions">
            <Button className="btnGreen" onClick={handleSend} disabled={!confirmcheck}>
              Send Email & Activate Support
            </Button>

            <Button className="btnOrange" onClick={() => setIsConfirm(false)}>
              Go Back & Edit
            </Button>

            <Button className="btnRed" onClick={handleDraft}>
              Cancel
            </Button>
          </div>
        </div>
      )}
    </AppModal>
  );
}
